(function () {
  const cache = new Map();

  function normalizeUrl(href) {
    return new URL(href, window.location.origin).toString();
  }

  function getMainProductSection() {
    const productInfo = document.querySelector('product-info');
    if (productInfo) return productInfo.closest('.shopify-section');

    const main = document.querySelector('[id^="MainProduct-"]');
    if (main) return main.closest('.shopify-section');

    return null;
  }

  function getSectionInstanceId(sectionEl) {
    const id = sectionEl && sectionEl.id ? sectionEl.id : '';
    if (id.startsWith('shopify-section-')) return id.replace('shopify-section-', '');
    return null;
  }

  async function fetchSectionHTML(productUrl, sectionInstanceId) {
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('sections', sectionInstanceId);

    const res = await fetch(url.toString(), {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) throw new Error('Failed to fetch section HTML');
    const json = await res.json();

    const html = json[sectionInstanceId];
    if (!html) throw new Error('No section HTML returned');
    return html;
  }

  function extractShopifySectionNode(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return (
      doc.querySelector('.shopify-section') ||
      doc.querySelector('[id^="shopify-section-"]') ||
      doc.body.firstElementChild
    );
  }

  function reinitAfterSwap() {
    if (window.Shopify && window.Shopify.PaymentButton) {
      try { window.Shopify.PaymentButton.init(); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
    window.dispatchEvent(new Event('resize'));
  }

  // --- Skeleton CSS injection (so you don't have to paste CSS elsewhere) ---
  function ensureSkeletonStylesInjected() {
    if (document.getElementById('ru-swap-skeleton-styles')) return;

    const style = document.createElement('style');
    style.id = 'ru-swap-skeleton-styles';
    style.textContent = `
      .ru-swap-skeleton{
        position:absolute; inset:0;
        background: rgba(255,255,255,0.72);
        backdrop-filter: blur(2px);
        display:grid; align-content:start;
        gap:12px; padding:16px;
        z-index:50;
      }
      .ru-swap-skel-box{
        height:14px; border-radius:999px;
        background: rgba(0,0,0,0.08);
        overflow:hidden; position:relative;
      }
      .ru-swap-skel-box::after{
        content:""; position:absolute; inset:0;
        transform: translateX(-100%);
        background: linear-gradient(90deg, transparent, rgba(0,0,0,0.08), transparent);
        animation: ruShimmer 1.05s infinite;
      }
      @keyframes ruShimmer { to { transform: translateX(100%); } }
      .ru-swap-skel-img{ height:220px; border-radius:16px; }
      .ru-swap-skel-btn{ height:44px; border-radius:12px; }
    `;
    document.head.appendChild(style);
  }

  function showSkeleton(sectionEl) {
    ensureSkeletonStylesInjected();

    // Ensure overlay can position correctly
    if (!sectionEl.style.position) sectionEl.style.position = 'relative';

    const skel = document.createElement('div');
    skel.className = 'ru-swap-skeleton';
    skel.innerHTML = `
      <div class="ru-swap-skel-box ru-swap-skel-img"></div>
      <div class="ru-swap-skel-box" style="width:70%"></div>
      <div class="ru-swap-skel-box" style="width:35%"></div>
      <div class="ru-swap-skel-box ru-swap-skel-btn"></div>
    `;
    sectionEl.appendChild(skel);
    return skel;
  }

  function removeSkeleton(skel) {
    if (skel && skel.parentNode) skel.parentNode.removeChild(skel);
  }

  async function prefetch(productUrl) {
    const section = getMainProductSection();
    if (!section) return;

    const sectionInstanceId = getSectionInstanceId(section);
    if (!sectionInstanceId) return;

    const key = normalizeUrl(productUrl) + '::' + sectionInstanceId;
    if (cache.has(key)) return;

    try {
      const html = await fetchSectionHTML(productUrl, sectionInstanceId);
      cache.set(key, html);
    } catch (e) {}
  }

  async function swapProduct(productUrl, { push = true } = {}) {
    const currentSection = getMainProductSection();
    if (!currentSection) {
      window.location.href = productUrl;
      return;
    }

    const sectionInstanceId = getSectionInstanceId(currentSection);
    if (!sectionInstanceId) {
      window.location.href = productUrl;
      return;
    }

    const key = normalizeUrl(productUrl) + '::' + sectionInstanceId;

    // Show skeleton after we know currentSection exists
    const skel = showSkeleton(currentSection);

    // Block interaction during swap
    currentSection.setAttribute('aria-busy', 'true');
    currentSection.style.pointerEvents = 'none';

    try {
      let html = cache.get(key);
      if (!html) {
        html = await fetchSectionHTML(productUrl, sectionInstanceId);
        cache.set(key, html);
      }

      const newSectionNode = extractShopifySectionNode(html);
      if (!newSectionNode) throw new Error('Could not parse section node');

      // Replace the entire section wrapper (keeps Dawn intact)
      currentSection.replaceWith(newSectionNode);

      if (push) {
        history.pushState({ productUrl: normalizeUrl(productUrl) }, '', normalizeUrl(productUrl));
      }

      reinitAfterSwap();
    } catch (err) {
      window.location.href = productUrl;
    } finally {
      // If replaceWith happened, the old section (and skeleton) is gone already.
      // This cleanup is still safe if it didn't replace.
      removeSkeleton(skel);
      try {
        currentSection.removeAttribute('aria-busy');
        currentSection.style.pointerEvents = '';
      } catch (e) {}
    }
  }

  function onClick(e) {
    const link = e.target.closest('a.ru-style-swap');
    if (!link) return;

    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const href = link.getAttribute('href');
    if (!href) return;

    const target = normalizeUrl(href);
    const current = normalizeUrl(window.location.href);
    if (target === current) return;

    e.preventDefault();
    swapProduct(target, { push: true });
  }

  // Prefetch on hover
  let hoverTimer = null;
  function onMouseOver(e) {
    const link = e.target.closest('a.ru-style-swap');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => prefetch(href), 80);
  }

  // Prefetch on touch
  function onTouchStart(e) {
    const link = e.target.closest('a.ru-style-swap');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    prefetch(href);
  }

  // Back/forward navigation
  window.addEventListener('popstate', (e) => {
    const url = (e.state && e.state.productUrl) ? e.state.productUrl : window.location.href;
    swapProduct(url, { push: false });
  });

  document.addEventListener('click', onClick, true);
  document.addEventListener('mouseover', onMouseOver, true);
  document.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });

  // Optional: prefetch first 2 styles on page load
  window.addEventListener('load', () => {
    const links = Array.from(document.querySelectorAll('a.ru-style-swap')).slice(0, 2);
    links.forEach((a, i) => {
      const href = a.getAttribute('href');
      if (href) setTimeout(() => prefetch(href), 150 + i * 100);
    });
  });
})();
